'use client';
import React from 'react';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';
import { useFamilyDemo } from '@/lib/familyDemoState';

interface AppLayoutProps {
  children: React.ReactNode;
  unreadAlerts?: number;
  unreadMessages?: number;
  hideNav?: boolean;
}

export default function AppLayout({
  children,
  unreadAlerts,
  unreadMessages,
  hideNav = false,
}: AppLayoutProps) {
  const { getUnreadAlertCount, getUnreadMessageCount } = useFamilyDemo();

  // Use provider counts if not explicitly passed
  const alertCount = unreadAlerts ?? getUnreadAlertCount();
  const messageCount = unreadMessages ?? getUnreadMessageCount();

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <AppHeader unreadCount={alertCount} />
      <main className="flex-1 overflow-y-auto overflow-x-hidden">
        {children}
      </main>
      {!hideNav && (
        <BottomNav alertCount={alertCount} messageCount={messageCount} />
      )}
    </div>
  );
}